import {
  CustomerPageNavigationBlock,
  isCustomerPageNavigationBlock
} from 'models/CustomerPageNavigationBlock';
import {
  HelpCenterNavigationBlock,
  isHelpCenterNavigationBlock
} from 'models/HelpCenterNavigationBlock';
import { PageState } from 'models/PageState';
import { ContactSection } from 'models/ContactSection';
import { StripeLink } from 'models/StripeLink';

export const selectSiteMode = (state: PageState) => state.appShell.siteMode;
export const selectChannel = (state: PageState) => state.appShell.channel;

export const selectBlackFridayStatus = (state: PageState): boolean => {
  return state.header.blackFridayActive;
};

export const selectCustomerPage = (state: PageState): CustomerPageNavigationBlock | undefined => {
  const nav = state.header.subNavigation;
  return nav === undefined ? nav : nav.find(isCustomerPageNavigationBlock);
};

export const selectHelpCenter = (state: PageState): HelpCenterNavigationBlock | undefined => {
  const nav = state.header.subNavigation;
  return nav === undefined ? nav : nav.find(isHelpCenterNavigationBlock);
};

export const selectHelpCenterStatus = (state: PageState): boolean => {
  return state.appShell.shouldUseHelpCenter;
};

export const selectContactSection = (state: PageState): ContactSection | undefined => {
  return state.header.contactSection;
};

export const selectLogoUrl = (state: PageState): string => state.appShell.logoUrl;

export const selectStripeLinks = (state: PageState): StripeLink[] | undefined => {
  return state.header.stripeLinks;
};
